const breakpoints = {
  SM: 360,
  MD: 720,
  LG: 1024
};

export default breakpoints;
